export default __webpack_public_path__ + "c818211fc678908e8a0a3c8170869221.png";